import React from 'react';

export default () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line
      x1="19"
      y1="5.55563"
      x2="5.05809"
      y2="19.4975"
      stroke="#151035"
      strokeWidth="2.2"
      strokeLinecap="round"
    />
    <line
      x1="1.1"
      y1="-1.1"
      x2="20.8168"
      y2="-1.1"
      transform="matrix(0.707107 0.707107 0.707107 -0.707107 5 4)"
      stroke="#151035"
      strokeWidth="2.2"
      strokeLinecap="round"
    />
  </svg>
);
